import { Controller } from "stimulus";


export default class extends Controller {


  connect() {
    window.dispatchEvent(new CustomEvent("edit-lock-activated"))
  }

  disconnect() {}

 
}


